import { Text } from "@ttc3k/trekker";
import { ReactElement } from "react";
import { RecipeVariantProps, sva } from "styled-system/css";
import { Flex } from "styled-system/jsx";

const reservationInfoCardRecipe = sva({
  slots: ["container", "title", "description"],
  base: {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "100",
      border: "2px solid",
      borderRadius: "100",
      px: "400",
      py: "300",
      w: "full",
    },
    title: {
      color: "text.dark",
    },
    description: {
      color: "text.dark",
    },
  },
  variants: {
    visual: {
      success: {
        container: {
          bgColor: "bg.success.lightest",
          borderColor: "border.success",
        },
        title: {
          color: "text.success.dark",
        },
        description: {
          color: "text.success.dark",
        },
      },
      highlight: {
        container: {
          bgColor: "bg.highlight.lightest",
          borderColor: "border.highlight",
        },
        title: {
          color: "text.highlight.dark",
        },
        description: {
          color: "text.highlight.dark",
        },
      },
      error: {
        container: {
          bgColor: "bg.error.lightest",
          borderColor: "border.error",
        },
        title: {
          color: "text.error.dark",
        },
        description: {
          color: "text.error.dark",
        },
      },
      "accent.blue": {
        container: {
          bgColor: "bg.accent.blue.lightest",
          borderColor: "border.accent.blue",
        },
        title: {
          color: "text.accent.blue.dark",
        },
        description: {
          color: "text.accent.blue.dark",
        },
      },
    },
  },
  defaultVariants: {
    visual: "success",
  },
});

type ReservationInfoCardRecipeVariants = RecipeVariantProps<
  typeof reservationInfoCardRecipe
>;

type ReservationInfoCardProps = {
  title?: string;
  description: ReactElement | string;
} & ReservationInfoCardRecipeVariants;

export const ReservationInfoCard = ({
  visual,
  title,
  description,
}: ReservationInfoCardProps) => {
  const styles = reservationInfoCardRecipe({ visual });

  return (
    <Flex className={styles.container}>
      {title && (
        <Text visual="bodySemiBold" className={styles.title}>
          {title}
        </Text>
      )}
      <Text className={styles.description}>{description}</Text>
    </Flex>
  );
};
